import { render, staticRenderFns } from "./ExpensesGeneral.vue?vue&type=template&id=23996020&"
import script from "./ExpensesGeneral.vue?vue&type=script&lang=js&"
export * from "./ExpensesGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports